import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import FormErrorMessage from '../../../../../atoms/FormErrorMessage';
import { ErrorType } from '../../../../../interfaces/merchants/resources/books';

const BlankMessage: FC = () => {
  const intl = useIntl();
  return (
    <FormErrorMessage>
      {intl.formatMessage({
        id: `books.errors.waitingList.blank`,
        defaultMessage: intl.formatMessage({ id: 'books.errors.blank' }),
      })}
    </FormErrorMessage>
  );
};

const TakenMessage: FC = () => {
  const intl = useIntl();
  return (
    <FormErrorMessage>
      {intl.formatMessage({
        id: `books.errors.waitingList.taken`,
        defaultMessage: intl.formatMessage({ id: 'books.errors.taken' }),
      })}
    </FormErrorMessage>
  );
};

const InvalidMessage: FC = () => {
  const intl = useIntl();
  return (
    <FormErrorMessage>
      {intl.formatMessage({
        id: `books.errors.waitingList.invalid`,
        defaultMessage: intl.formatMessage({
          id: 'books.errors.invalid',
        }),
      })}
    </FormErrorMessage>
  );
};

const InvalidDomainMessage: FC = () => {
  const intl = useIntl();
  return (
    <FormErrorMessage>
      {intl.formatMessage({
        id: `books.errors.waitingList.invalidDomain`,
        defaultMessage: intl.formatMessage({
          id: 'books.errors.invalidDomain',
        }),
      })}
    </FormErrorMessage>
  );
};

const ERROR_COMPONENTS: {
  [error in ErrorType]: React.FC;
} = {
  [ErrorType.Blank]: BlankMessage,
  [ErrorType.Taken]: TakenMessage,
  [ErrorType.Invalid]: InvalidMessage,
  [ErrorType.InvalidDomain]: InvalidDomainMessage,
  [ErrorType.LoginFailed]: InvalidMessage,
};

interface Props {
  errors?: ErrorType[];
}

const InputBookingWaitingListErrorMessage: FC<Props> = (props) => {
  const { errors } = props;
  if (!errors) return null;
  if (errors.length === 0) return null;

  return (
    <>
      {errors.map((error, index) => {
        const Component = ERROR_COMPONENTS[error];
        return <Component key={index} />;
      })}
    </>
  );
};

export default InputBookingWaitingListErrorMessage;
